// Copyright Epic Games, Inc. All Rights Reserved.

import { Box, Grid, Typography } from "@material-ui/core";
import { BytesDisplay } from "./BytesDisplay";
import { InstallationProgressBar } from "./InstallationProgressBar";
import React from "react";
import styled from "styled-components";
import {
  useInstallationGroupProgress,
  useInstallationProgress,
} from "../../store/installation/hooks";
import { EInstallationStatus } from "../../services/EOSHelperAPI";
import { CancelButton } from "./CancelButton";

const TextCenter = styled(Typography)({
  "text-align": "center",
  width: "max-content",
  position: "relative",
});

const FlexGrid = styled(Grid)(() => ({
  display: "flex",
}));

const statusToNumberMap = {
  [EInstallationStatus.Queued]: 0,
  [EInstallationStatus.Initializing]: 1,
  [EInstallationStatus.Resuming]: 2,
  [EInstallationStatus.Installing]: 3,
  [EInstallationStatus.BuildVerification]: 4,
  [EInstallationStatus.CleanUp]: 5,
  [EInstallationStatus.PrerequisitesInstall]: 6,
  [EInstallationStatus.Completed]: 7,
  [EInstallationStatus.Paused]: 8,
};

export function InstallationProgress(): JSX.Element {
  const progress = useInstallationProgress();
  const showDownloadProgress =
    statusToNumberMap[progress.status] < statusToNumberMap.BuildVerification;
  const {
    currentTaskNumber,
    numInstallations,
  } = useInstallationGroupProgress();

  return (
    <FlexGrid direction="column" justify="center" alignItems="center" container>
      <InstallationProgressBar
        variant={
          progress.completionProgress < 0 ? "indeterminate" : "determinate"
        }
        color="primary"
        value={progress.completionProgress * 100}
      />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        position="relative"
        height="30px"
      >
        <Box display="flex">
          <Typography variant="caption" style={{ marginRight: "9px" }}>
            {currentTaskNumber} / {numInstallations}
          </Typography>
          {showDownloadProgress && (
            <TextCenter variant="caption" color="textSecondary">
              <BytesDisplay bytes={progress.downloadedBytes} /> {" / "}
              <BytesDisplay bytes={progress.totalDownloadRequiredBytes} /> (
              <BytesDisplay bytes={progress.averageDownloadSpeed} />
              {"/s"})
            </TextCenter>
          )}
        </Box>

        <CancelButton />
      </Box>
    </FlexGrid>
  );
}
